export default "__VITE_ASSET__a352c7ac__"